function Analytics() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Total Crimes</h3>
          <p className="text-3xl font-bold text-blue-600">12,847</p>
          <p className="text-sm text-gray-500">Last 30 days</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Predicted Crimes</h3>
          <p className="text-3xl font-bold text-green-600">8,234</p>
          <p className="text-sm text-gray-500">Next 7 days</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Accuracy</h3>
          <p className="text-3xl font-bold text-purple-600">87.3%</p>
          <p className="text-sm text-gray-500">Model performance</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Risk Level</h3>
          <p className="text-3xl font-bold text-orange-600">Medium</p>
          <p className="text-sm text-gray-500">Current assessment</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Crime Trends</h3>
          <div className="h-64 bg-gray-100 rounded flex items-center justify-center">
            <p className="text-gray-500">Chart placeholder</p>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Top Crime Types</h3>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Theft</span>
              <span className="text-sm font-medium">3,245</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Assault</span>
              <span className="text-sm font-medium">2,187</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Burglary</span>
              <span className="text-sm font-medium">1,923</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Vandalism</span>
              <span className="text-sm font-medium">1,456</span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Model Performance</h3>
        <div className="h-64 bg-gray-100 rounded flex items-center justify-center">
          <p className="text-gray-500">Analytics chart placeholder</p>
        </div>
      </div>
    </div>
  )
}

export default Analytics
